module.exports = __webpack_public_path__ + "static/media/20210401_223358_370_IMG_0010.95fe6f31.jpg";